<template>
  <div class="flex flex-col gap-1">
    <span class="wrap-break-word whitespace-pre-wrap">{{ described.line }}</span>
    <template v-if="described.detail">
      <button
        type="button"
        class="w-fit cursor-pointer text-xs text-text-secondary underline"
        :aria-expanded="isOpen"
        @click="isOpen = !isOpen">
        {{ isOpen ? $t('W: Skjul') : described.detailLabel }}
      </button>
      <span
        v-if="isOpen"
        class="rounded-md border border-border-subtle bg-surface-muted px-3 py-2 text-xs wrap-break-word whitespace-pre-wrap text-text-secondary">
        {{ described.detail }}
      </span>
    </template>
  </div>
</template>

<script lang="ts">
import { describeBcError } from '@/globals/typescript/utils/businessCentralErrors'

/**
 * Shows a failure from the BC push: Milva's own errors as a Danish line, BC's own answer under a
 * short heading — each with the original text behind a fold. See `businessCentralErrors.ts`.
 */
export default {
  name: 'BcErrorMessage',

  props: {
    message: { type: String, required: true },
  },

  data() {
    return { isOpen: false }
  },

  computed: {
    described() {
      return describeBcError(this.message)
    },
  },

  watch: {
    // A new failure starts folded, however the last one was left.
    message() {
      this.isOpen = false
    },
  },
}
</script>
